<script>
    import { getIsIncludedStreaming, getStreamingLogos } from '../utils/utils';
    import {
        MULTI_CATEGORIES,
        TV_CATEGORIES,
        NETFLIX_CATEGORIES,
        LALIGA_CATEGORIES,
        IS_SKEELO_INCLUDED,
        APPLE_TV_INCLUDED,
        CLIP_PLUS_INCLUDED,
    } from '../utils/constant';

    export let plan, category, checkedCombos;

    $: includedStreaming = getIsIncludedStreaming(plan, checkedCombos) || {};

    $: streamingFlags = {
        shouldShowViXPremium:
            MULTI_CATEGORIES.has(category) || TV_CATEGORIES.has(category),
        shouldShowMaxAdd:
            MULTI_CATEGORIES.has(category) &&
            includedStreaming.IS_MAX_ADD_INCLUDED,
        shouldShowMax:
            MULTI_CATEGORIES.has(category) && includedStreaming.IS_MAX_INCLUDED,
        shouldShowNetflixEstandarAnuncios:
            NETFLIX_CATEGORIES.has(category) &&
            includedStreaming.IS_NETFLIX_ADD_INCLUDED,
        shouldShowNetflixEstandar:
            NETFLIX_CATEGORIES.has(category) &&
            includedStreaming.IS_NETFLIX_ESTANDAR_INCLUDED,
        shouldShowLaLiga:
            LALIGA_CATEGORIES.has(category) &&
            includedStreaming.IS_LALIGA_INCLUDED,
        shouldShowSkeelo: IS_SKEELO_INCLUDED.has(category),
        shouldShowAppleTv:
            APPLE_TV_INCLUDED.has(category) &&
            includedStreaming.IS_APPLE_TV_INCLUDED,
        shouldShowClipPlus: CLIP_PLUS_INCLUDED.has(category),
    };

    $: logos = getStreamingLogos(streamingFlags) || [];
</script>

<div class="plan-card__extras">
    {#each logos as { src, alt, shouldShow, variant } (src)}
        {#if shouldShow}
            <img {src} {alt} class={variant} />
        {/if}
    {/each}
</div>
